import {Accordion, Badge, Button, Card, ListGroup, Modal} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import './multiselect.css';
import {IconButton, AppBar , Toolbar} from "@material-ui/core";
import Select from "react-select";
import {MultiCascader} from "rsuite";
import {Close} from "@material-ui/icons";
import _ from "lodash";
import {useDispatch, useSelector} from "react-redux";
import {fetchBuildQuiz, fetchMultiSelectFormData} from "../../redux/actions/actions";

const SelectedModules =({selectedModulesHierarchies})=>{
    return selectedModulesHierarchies.map((selected , index )=>{
        return(
            <Badge  key={index} className="m-1" variant="info"><div className="d-flex justify-content-around align-items-center"><div className="pr-1">
                {selected.map((level , index)=>{
                    console.log('level =', level);
                    return index+1 !== selected.length ?  level + ' > ' : level;
                })}
            </div></div></Badge>
        )
    });
}


const ModulesAccordionContent=({loading , data , onChange , onSelect , onCheck , selectedModulesHierarchies})=>{
    if (loading) return null;
    console.log('Dataaaa =' , data);

    return (
        <div className="accordion__body--text">
            <MultiCascader
                inline
                data={data}
                searchable={true}
                menuHeight={200}
                menuWidth={300}
                size="lg"
                onChange={onChange}
                onSelect={onSelect}
                onCheck={onCheck}
            />
            <div className="w-100">
                <SelectedModules selectedModulesHierarchies={selectedModulesHierarchies}/>
            </div>
        </div>
    )


}

export default function MultiSelect(){
    const exampleData =[{
        value: 'Parent 1',
        label: 'Parent 1',
        children: [{
            value : 'Elem 11',
            label : 'Elem 11'
        },{
            value : 'Elem 12',
            label : 'Elem 12',
            children : [
                {
                    value : 'Elem 121',
                    label : 'Elem 121'
                },
                {
                    value : 'Elem 122',
                    label : 'Elem 122'
                },
                {
                    value : 'Elem 123',
                    label : 'Elem 123'
                }, {
                    value : 'Elem 124',
                    label : 'Elem 124'
                },
                {
                    value : 'Elem 125',
                    label : 'Elem 125'
                }, {
                    value : 'Elem 126',
                    label : 'Elem 126'
                },
                {
                    value : 'Elem 127',
                    label : 'Elem 127'
                }, {
                    value : 'Elem 128',
                    label : 'Elem 128'
                }
            ]
        },{
            value : 'Elem 13',
            label : 'Elem 13'
        }]
    } , {
        value : 'Parent 2',
        label : 'Parent 2',
        children: [{
            value: 'Elem 21',
            label : 'Elem 21'
        },{
            value : 'Elem 22',
            label : 'Elem 22'
        }]
    }, {
        value : 'Parent 3',
        label : 'Parent 3'
    }];

    const [selectedOption, setSelectedOption] = useState(null);
    const [isDifficultyModalOpen , setDifficultyModalOpen] = useState(false);
    const [isPreferancesModalOpen , setPreferancesModalOpen] = useState(false);
    const [isModulesModalOpen , setModulesModalOpen] = useState(false);
    const [allModules , setAllModules]=useState(exampleData);
    const [selectedModules , setSelectedModules]=useState([]);
    const [selectedModulesHierarchies , setSelectedModulesHierarchiers]=useState([]);
    const [activeAccordionActiveHeaderFilter, setActiveAccordionActiveHeaderFilter] = useState(0);
    const [activeAccordionActiveHeaderInclude, setActiveAccordionActiveHeaderInclude] = useState(0);
    const dispatch = useDispatch();
    const [selectedTypes , setSelectedTypes]=useState([]);
    const [selectedDifficulties , setSelectedDifficulties]=useState([]);
    const [selectedFilters , setSelectedFilters]=useState([]);
    const [selectedTagsId , setSelectedTagsId]=useState([]);

    let multiSelectReducer=useSelector(state=>state.multiSelect);
    useEffect(()=>{
        // MODULES AND TAGS
        dispatch(fetchMultiSelectFormData());
    }, []);

    const handleTypeChange = (type)=>{
        // the type was unchecked
        if(selectedTypes.indexOf(type)===-1){
            setSelectedTypes(oldState=>oldState.concat(type))
        }
        // the type was checked
        else{
            setSelectedTypes(oldState=>oldState.filter(typeArr=>typeArr!==type))
        }
    }
    const handleDiffChange = (diff)=>{
        // the difficulty was unchecked
        if(selectedDifficulties.indexOf(diff)===-1){
            setSelectedDifficulties(oldState=>oldState.concat(diff))
        }
        // the difficulty was checked
        else{
            setSelectedDifficulties(oldState=>oldState.filter(typeArr=>typeArr!==diff))
        }
    }
    const handleFiltersChange = (filter)=>{
        // the difficulty was unchecked
        if(selectedFilters.indexOf(filter)===-1){
            setSelectedFilters(oldState=>oldState.concat(filter))
        }
        // the difficulty was checked
        else{
            setSelectedFilters(oldState=>oldState.filter(typeArr=>typeArr!==filter))
        }
    }

    const handleTagsChange = (tagId)=>{
        // the difficulty was unchecked
        if(selectedTagsId.indexOf(tagId)===-1){
            setSelectedTagsId(oldState=>oldState.concat(tagId))
        }
        // the difficulty was checked
        else{
            setSelectedTagsId(oldState=>oldState.filter(typeArr=>typeArr!==tagId))
        }
    }
    const handleQuizSizeChange = (selectedOption) => {
        setSelectedOption(selectedOption)
        console.log(`Option selected:`, selectedOption);
    };
    const submitBuildQuiz =()=>{
        const toPost ={
            topics : selectedModules,
            types : selectedTypes,
            difficulties : selectedDifficulties,
            tags : selectedTagsId,
            filters : selectedFilters,
            count : selectedOption,
        }
        console.log(' I WILL POST THAT :', toPost);
        dispatch(fetchBuildQuiz(toPost))
        // openRevisionWindow();

    }

    const DifficultyAccordionContent=()=>{
        return(
            <div className="basic-form">
                <form onSubmit={(e) => e.preventDefault()}>
                    <div className="form-group d-flex justify-content-around">
                        <div className="form-check form-check-inline">
                            <label className="difficultyCheckBox form-check-label">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    name='Easy'
                                    checked={selectedDifficulties.includes('Easy')}
                                    onChange={(e)=>handleDiffChange(e.target.name)}
                                />
                                Facile
                            </label>
                        </div>
                        <div className="form-check form-check-inline">
                            <label className="difficultyCheckBox form-check-label">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    name='Medium'
                                    checked={selectedDifficulties.includes('Medium')}
                                    onChange={(e)=>handleDiffChange(e.target.name)}
                                />
                                Moyenne
                            </label>
                        </div>
                        <div className="form-check form-check-inline">
                            <label className="difficultyCheckBox form-check-label">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    name='Hard'
                                    checked={selectedDifficulties.includes('Hard')}
                                    onChange={(e)=>handleDiffChange(e.target.name)}
                                />
                                Difficile
                            </label>
                        </div>
                    </div>
                </form>
            </div>
        )

    }
    const TagsAccordionContent=({loading , data})=>{
        if(loading) return null;
        return(
            <div className="basic-form">
                <form onSubmit={(e) => e.preventDefault()}>
                    {
                        data.map((tag , index)=>{
                            if(index%2===1) return null
                            else  {
                                return(
                                    <div className="form-group mb-0 mb-lg-1 d-flex flex-column flex-lg-row justify-content-around">
                                        <div className="preferancesCheckBoxContainer form-check form-check-inline">
                                            <label className="preferancesCheckBox form-check-label">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    name={tag.id}
                                                    checked={selectedTagsId.includes(tag.id)}
                                                    onChange={(e)=>handleTagsChange(tag.id)}
                                                />
                                                {tag.name}
                                            </label>
                                        </div>
                                        {
                                            index+1  < data.length ? (
                                                <div className="preferancesCheckBoxContainer form-check form-check-inline">
                                                    <label className="preferancesCheckBox  form-check-label">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            name={data[index+1].id}
                                                            checked={selectedTagsId.includes(data[index+1].id)}
                                                            onChange={(e)=>handleTagsChange(data[index+1].id)}
                                                        />
                                                        {data[index+1].name}
                                                    </label>
                                                </div>
                                            ) :null
                                        }
                                    </div>
                                )
                            }
                        })
                    }
                </form>
            </div>

        )
    }

    const PreferancesAccordionContent=()=>{
        return(
            <div className="basic-form">
                <form onSubmit={(e) => e.preventDefault()}>
                    <div className="form-group mb-0 mb-lg-1 d-flex flex-column flex-lg-row justify-content-around">
                        <div className="preferancesCheckBoxContainer form-check form-check-inline">
                            <label className="preferancesCheckBox form-check-label">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                />
                                Questions non consultées
                            </label>
                        </div>
                        <div className="preferancesCheckBoxContainer form-check form-check-inline">
                            <label className="preferancesCheckBox  form-check-label">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    name='Answered False'
                                    checked={selectedFilters.includes('Answered False')}
                                    onChange={(e)=>handleFiltersChange(e.target.name)}
                                />
                                Questions déja fausses
                            </label>
                        </div>
                    </div>
                    <div className="form-group mb-0 mb-lg-1 d-flex flex-column flex-lg-row  justify-content-around">
                        <div className="preferancesCheckBoxContainer form-check form-check-inline">
                            <label className="preferancesCheckBox  form-check-label">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    name='Explanation'
                                    checked={selectedFilters.includes('Explanation')}
                                    onChange={(e)=>handleFiltersChange(e.target.name)}
                                />
                                Questions avec explications seulement
                            </label>
                        </div>
                        <div className="preferancesCheckBoxContainer form-check form-check-inline">
                            <label className="preferancesCheckBox  form-check-label">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    name='With Note'
                                    checked={selectedFilters.includes('With Note')}
                                    onChange={(e)=>handleFiltersChange(e.target.name)}

                                />
                                Questions avec notes personnelles
                            </label>
                        </div>
                    </div>
                </form>
            </div>

        )

    }
    const TypesAccordionContent=()=>{
        return(
            <div className="basic-form">
                <form onSubmit={(e) => e.preventDefault()}>
                    <div className="form-group mb-0 mb-lg-1 d-flex flex-column flex-lg-row justify-content-around">
                        <div className=" form-check form-check-inline">
                            <label className="preferancesCheckBox form-check-label">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    name='QCU'
                                    checked={selectedTypes.includes('QCU')}
                                    onChange={(e)=>handleTypeChange(e.target.name)}
                                />
                               Questions à choix unique (QCU)
                            </label>
                        </div>
                        <div className=" form-check form-check-inline">
                            <label className="preferancesCheckBox  form-check-label">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    name='QCM'
                                    checked={selectedTypes.includes('QCM')}
                                    onChange={(e)=>handleTypeChange(e.target.name)}
                                />
                                Questions à choix multiples (QCM)
                            </label>
                        </div>
                    </div>
                    <div className="form-group mb-0 mb-lg-1 d-flex flex-column flex-lg-row  justify-content-around">
                        <div className=" form-check form-check-inline">
                            <label className="preferancesCheckBox  form-check-label">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    name='CCQCM'
                                    checked={selectedTypes.includes('CCQCM')}
                                    onChange={(e)=>handleTypeChange(e.target.name)}
                                />
                                Cas Cliniques (CCQCM)
                            </label>
                        </div>

                    </div>
                </form>
            </div>

        )

    }
    const handleChangeSelectedModules=(value , event)=> {
        console.log('handleChange', value);
        setSelectedModules(value);
    }
    const handleCheckModules=(value , item, checked,event )=> {
        console.log('value =', value);
        console.log('item =', item);
        let newSelectedHierarchies = [...selectedModulesHierarchies];
        if(checked){
            let lastItem = value[value.length-1];
            console.log('last item added ', lastItem);
            console.log('actual item checked :', item.value);
            let parents =[];
            let parentsLabels = [];
            let actualParent=item.parent;
            while(actualParent){
                parentsLabels.unshift(actualParent);
                parents.unshift(actualParent.value);
                actualParent=actualParent.parent;
            }
            console.log('PARENTS =', parents);
            parents.push(item.value);
            parentsLabels.push(item);
            console.log('the hirerachy LABEELS ' , parentsLabels);
            console.log('The hierarchy =', parents);
            if(lastItem===item.value){
                console.log(' we added that item !');
                newSelectedHierarchies.push(parents);
            }else{
                console.log('all the elements of the parent are checked ! : ', item.parent);
                console.log('remember the last item added is :', lastItem);
                let parentLevel=1;
                let actualParent = item.parent;
                while(actualParent.value!==lastItem){
                    parentLevel++;
                    actualParent=actualParent.parent
                }
                console.log('The targeted parent :' , actualParent);
                console.log('its level : ', parentLevel);
                newSelectedHierarchies = newSelectedHierarchies.filter(hierarchy=>hierarchy.indexOf(actualParent.value)===-1);
                console.log('The hierarchy after checking all the children :', newSelectedHierarchies);
                for (let i = 0; i < parentLevel; i++) {
                    parents.pop();
                }
                console.log('the new added ( parent ) :', parents);
                newSelectedHierarchies.push(parents);
            }
            console.log('Final Selected Hierarchies :' , newSelectedHierarchies);
            // in case it was 'undefined' we have to remove all its children from the hierarchy ( for the children : the parent isn't the last item and it exists
            newSelectedHierarchies= newSelectedHierarchies.filter(hierarchy=>hierarchy.indexOf(item.value)===hierarchy.length-1 ||hierarchy.indexOf(item.value)===-1  )
        }else{
            console.log('The actual hierarchy =', selectedModulesHierarchies);
            console.log('actual item UNchecked :', item.value);
            // check if i uncheck the last elemnt in my hierarchy ( if it's teh case i will just remove it , that means he hasn't a parent of  checked elements )
            if(newSelectedHierarchies.filter(hierarchy=>hierarchy.indexOf(item.value)===hierarchy.length-1).length===1){
                console.log("I just UNchecked the lowest level !");
                newSelectedHierarchies=newSelectedHierarchies.filter(hierarchy=>hierarchy.indexOf(item.value)===-1);
            }
            // I unchecked
            else{
                console.log('i UNchecked a children whose parent is checked !')
                let parents =[];
                let actualParent=item.parent;
                let parentLevel=1;
                while(actualParent){
                    parents.unshift(actualParent.value);
                    actualParent=actualParent.parent;
                }
                console.log('PARENTS =', parents);
                let actualParentValue=parents[parents.length-1];
                actualParent =item.parent;
                while(newSelectedHierarchies.filter(hierarchy=>hierarchy.indexOf(actualParent.value)===hierarchy.length-1).length===0) {

                    parentLevel++;
                    actualParent=actualParent.parent

                }
                console.log('The targeted parent :' , actualParent);
                console.log('its level : ', parentLevel);

                if(parentLevel===1){
                    // I remove the parent
                    newSelectedHierarchies=newSelectedHierarchies.filter(hierararchy=>hierararchy.indexOf(actualParent.value)===-1)
                    actualParent.children.forEach(child=>{
                        // I add to the hierarchy all the siblings
                        if(child.value!==item.value){
                            newSelectedHierarchies.push([...parents , child.value]);
                        }
                    })
                }else{
                    actualParent=item.parent;
                    let parentToRemove
                    let clonedParents = [...parents]
                    for (let i = 0; i < parentLevel; i++) {
                        // I remove each parent
                        if(i===0){
                            parentToRemove=item.value;
                        }else{
                            parentToRemove=parents[parents.length-i];
                        }
                        console.log('parent to remove and to display his siblings : ', parentToRemove);
                        newSelectedHierarchies=newSelectedHierarchies.filter(hierararchy=>hierararchy.indexOf(actualParent.value)!==hierararchy.length-1)
                        actualParent.children.forEach(child=>{
                            // I add to the hierarchy all the siblings
                            if(child.value!==parentToRemove){
                                newSelectedHierarchies.push([...clonedParents, child.value]);
                            }
                        });
                        actualParent=actualParent.parent;
                        clonedParents.pop();
                    }
                }
            }
            // let parents =[];
            // let actualParent=item.parent;
            // while(actualParent){
            //     parents.unshift(actualParent.value);
            //     actualParent=actualParent.parent;
            // }
            // console.log('PARENTS =', parents);
            // parents.push(item.value);
            // console.log('The hierarchy =', parents);
        }
        setSelectedModulesHierarchiers(newSelectedHierarchies.sort((a,b)=>a.length-b.length));
        // setSelectedModules(value);

        // console.log('item =', item);
        // console.log('event =', checked);
        // console.log('event  : ', event);
        // setTimeout(()=>{

        // }, 100)
        // const wasChecked =event.target.children[0].checked;
        // let newSelectedModules=[...selectedModules];
        // if(wasChecked===false){
        //     newSelectedModules.push({
        //         element : node ,
        //         path : activePaths
        //     });
        //     setSelectedModules(newSelectedModules);
        // }else if (wasChecked===true){
        //     setSelectedModules(newSelectedModules.filter(selectedModule=> !_.isEqual(selectedModule.node ,  node)  && !_.isEqual (selectedModule.path , activePaths)));
        // }
        // setSelectedModules(oldState)
    }

    const options = [
        { value: 25, label: 25 },
        { value: 50, label: 50 },
        { value: 100, label: 100 },
    ];
    const customSelectStyles = {
        option: (provided, state) => ({
            ...provided,
            // borderBottom: '1px dotted pink',
            color: state.isSelected ? 'rgba(0,0,0,1)' : 'rgba(0,0,0,0.5)',
            // padding: 20,
        }),
        // control: () => ({
        //     // none of react-select's styles are passed to <Control />
        //     width: 200,
        // }),
        // singleValue: (provided, state) => {
        //     const opacity = state.isDisabled ? 0.5 : 1;
        //     const transition = 'opacity 300ms';
        //
        //     return { ...provided, opacity, transition };
        // }
    }


    const Modals=()=>{
        const ModulesModal=()=>{
            return null
        }
        return(
            <React.Fragment>
            </React.Fragment>
        )
    }

    const handleSelectModules=(node, activePaths, concat, event)=> {
        setTimeout(()=>{
            console.log('parent target =', event.target.parentNode.querySelector("input[type='checkbox']"));
            let theCheckBox=event.target.parentNode.querySelector("input[type='checkbox']");
            if(!node.children && theCheckBox.checked && !event.target.classList.contains('rs-checkbox-wrapper') ){
                console.log('event target =', event.target)
                let checkBoxToCheck = event.target.parentNode.querySelector(".rs-checkbox-wrapper")
                console.log('I must check it !' ,checkBoxToCheck );

                checkBoxToCheck.click();
            }
            console.log('node =', node)
            const elem=event.target;
            console.log('ELEM =' , elem)
            let div=elem;
            while(!div.classList.contains('rs-picker-cascader-menu-column')){
                div=div.parentElement;
                console.log('Actual DIV =', div);
            }
            let xPositionSibling=div.nextSibling?.offsetLeft;
            console.log('Position Sibling =', xPositionSibling);
            while(div.previousSibling) {
                div = div.previousSibling;
            }
            let xPositionFirstParent= div.offsetLeft;
            console.log('Position parent =', xPositionFirstParent);
            if(xPositionSibling){
                let scrollContainer=document.querySelector('.rs-picker-cascader-menu-items');
                scrollContainer.scrollTo({
                    behavior : 'smooth',
                    left : xPositionSibling-xPositionFirstParent
                })
            }
        },100)

    }

    const openRevisionWindow=()=>{
            let width = window.screen.availWidth;
            let height = window.screen.availHeight;
            window.open(`${process.env.REACT_APP_WEBSITE_URL}/revision/16`,'_blank',"height="+height+",width="+width+", toolbar=no, top=0,left=0,location=no,menubar=no, directories=no, status=no, menubar=no, scrollbars=yes,resizable=no");
    }

    return (
        <React.Fragment>
            <div className="container-fluid">
                <div className=" profile card card-body p-3">

                    <div>
                        <div className="pb-2 mt-2 mb-2">Inclure les questions par</div>
                        <Accordion
                            className="accordion accordion-primary-solid accordion-bordered accordion accordion"
                            defaultActiveKey="0"
                        >
                            <div className="accordion__item" key={1}>
                                <Accordion.Toggle
                                    as={Card.Text}
                                    eventKey={`${1}`}
                                    className={`accordion__header ${
                                        activeAccordionActiveHeaderInclude === 1
                                            ? ""
                                            : "collapsed"
                                    } accordion__header--primary`}
                                    onClick={() =>
                                        setActiveAccordionActiveHeaderInclude(
                                            activeAccordionActiveHeaderInclude === 1
                                                ? -1
                                                : 1
                                        )
                                    }
                                >
                                    <span className="accordion__header--icon"></span>
                                    <span className="accordion__header--text">
                                        Des modules
                                     </span>
                                    <span className="accordion__header--indicator "></span>
                                </Accordion.Toggle>
                                <Accordion.Collapse
                                    eventKey={`${1}`}
                                    className="accordion__body"
                                >
                                    <ModulesAccordionContent loading={multiSelectReducer.modules.loading} data={multiSelectReducer.modules.data} onChange={handleChangeSelectedModules}  onSelect={handleSelectModules} onCheck={handleCheckModules} selectedModulesHierarchies={selectedModulesHierarchies}/>
                                </Accordion.Collapse>
                            </div>
                            <div className="accordion__item" key={2}>
                                <Accordion.Toggle
                                    as={Card.Text}
                                    eventKey={`${2}`}
                                    className={`accordion__header ${
                                        activeAccordionActiveHeaderInclude === 2
                                            ? ""
                                            : "collapsed"
                                    } accordion__header--primary`}
                                    onClick={() =>
                                        setActiveAccordionActiveHeaderInclude(
                                            activeAccordionActiveHeaderInclude === 2
                                                ? -1
                                                : 2
                                        )
                                    }
                                >
                                    <span className="accordion__header--icon"></span>
                                    <span className="accordion__header--text">
                                        Des sources
                                     </span>
                                    <span className="accordion__header--indicator "></span>
                                </Accordion.Toggle>
                                <Accordion.Collapse
                                    eventKey={`${2}`}
                                    className="accordion__body"
                                >
                                    <div className="accordion__body--text">
                                        <TagsAccordionContent loading={multiSelectReducer.tags.loading} data={multiSelectReducer.tags.data}/>
                                    </div>
                                </Accordion.Collapse>
                            </div>
                        </Accordion>
                    </div>
                </div>
                <div className=" profile card card-body p-3">
                    <div>
                        <div className="pb-2 mt-2 mb-2">Filtrer les questions par</div>
                        <Accordion
                            className="accordion accordion-primary-solid accordion-bordered accordion accordion"
                            defaultActiveKey="0"
                        >
                            <div className="accordion__item" key={1}>
                                <Accordion.Toggle
                                    as={Card.Text}
                                    eventKey={`${1}`}
                                    className={`accordion__header ${
                                        activeAccordionActiveHeaderFilter === 1
                                            ? ""
                                            : "collapsed"
                                    } accordion__header--primary`}
                                    onClick={() =>
                                        setActiveAccordionActiveHeaderFilter(
                                            activeAccordionActiveHeaderFilter === 1
                                                ? -1
                                                : 1
                                        )
                                    }
                                >
                                    <span className="accordion__header--icon"></span>
                                    <span className="accordion__header--text">
                                        Type
                                     </span>
                                    <span className="accordion__header--indicator "></span>
                                </Accordion.Toggle>
                                <Accordion.Collapse
                                    eventKey={`${1}`}
                                    className="accordion__body"
                                >
                                    <div className="accordion__body--text">
                                        <TypesAccordionContent/>
                                    </div>
                                </Accordion.Collapse>
                            </div>
                            <div className="accordion__item" key={2}>
                                <Accordion.Toggle
                                    as={Card.Text}
                                    eventKey={`${2}`}
                                    className={`accordion__header ${
                                        activeAccordionActiveHeaderFilter === 2
                                            ? ""
                                            : "collapsed"
                                    } accordion__header--primary`}
                                    onClick={() =>
                                        setActiveAccordionActiveHeaderFilter(
                                            activeAccordionActiveHeaderFilter === 2
                                                ? -1
                                                : 2
                                        )
                                    }
                                >
                                    <span className="accordion__header--icon"></span>
                                    <span className="accordion__header--text">
                                        Difficulté
                                     </span>
                                    <span className="accordion__header--indicator "></span>
                                </Accordion.Toggle>
                                <Accordion.Collapse
                                    eventKey={`${2}`}
                                    className="accordion__body"
                                >
                                    <div className="accordion__body--text">
                                        <DifficultyAccordionContent/>
                                    </div>
                                </Accordion.Collapse>
                            </div>
                            <div className="accordion__item" key={3}>
                                <Accordion.Toggle
                                    as={Card.Text}
                                    eventKey={`${3}`}
                                    className={`accordion__header ${
                                        activeAccordionActiveHeaderFilter === 3
                                            ? ""
                                            : "collapsed"
                                    } accordion__header--primary`}
                                    onClick={() =>
                                        setActiveAccordionActiveHeaderFilter(
                                            activeAccordionActiveHeaderFilter === 3
                                                ? -1
                                                : 3
                                        )
                                    }
                                >
                                    <span className="accordion__header--icon"></span>
                                    <span className="accordion__header--text">
                                        Prèfèrances
                                     </span>
                                    <span className="accordion__header--indicator "></span>
                                </Accordion.Toggle>
                                <Accordion.Collapse
                                    eventKey={`${3}`}
                                    className="accordion__body"
                                >
                                    <div className="accordion__body--text">
                                        <PreferancesAccordionContent/>
                                    </div>
                                </Accordion.Collapse>
                            </div>
                        </Accordion>
                    </div>
                </div>

                <Modals/>
                <AppBar position="sticky" color="primary" style={{top : 'auto' , bottom : 0, zIndex : 2}}>
                    <Toolbar className="pt-lg-2 pb-lg-2 pb-2">
                        <div className="d-flex justify-content-between align-items-center w-100">
                            <div style={{textAlign : 'center' }} className="d-flex flex-column">
                                <div>0</div>
                                <div>Questions</div>
                            </div>
                            <div>
                                <div style={{textAlign : 'center' }} className="d-flex flex-column">
                                    <div>Max Quiz Size</div>
                                    <div>
                                        <Select
                                            placeholder=''
                                            menuPlacement="top"
                                            value={selectedOption}
                                            onChange={handleQuizSizeChange}
                                            options={options}
                                            style={{
                                                lineHeight: "40px",
                                                // color: "#7e7e7e",
                                                paddingLeft: " 15px",
                                            }}
                                            styles={customSelectStyles}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div>
                                <Button onClick={()=>submitBuildQuiz()} variant="primary btn-rounded">Build Quiz</Button>
                            </div>
                        </div>

                        {/*<IconButton edge="start" color="inherit" aria-label="open drawer">*/}
                        {/*    <MenuIcon />*/}
                        {/*</IconButton>*/}
                        {/*<Fab color="secondary" aria-label="add" className={classes.fabButton}>*/}
                        {/*    <AddIcon />*/}
                        {/*</Fab>*/}
                        {/*<div className={classes.grow} />*/}
                        {/*<IconButton color="inherit">*/}
                        {/*    <SearchIcon />*/}
                        {/*</IconButton>*/}
                        {/*<IconButton edge="end" color="inherit">*/}
                        {/*    <MoreIcon />*/}
                        {/*</IconButton>*/}
                    </Toolbar>
                </AppBar>
            </div>

        </React.Fragment>



    )
}
